import React from 'react';
import { RegistrationForm } from 'components/RegistrationForm/RegistrationForm';

export const RegistrationPage = () => {
  return <RegistrationForm />;
};
